<template>
  <div class="flex flex-col gap-8 mt-10">
    <div>
      <p class="button-2 pb-2">First name</p>
      <BaseInput
        v-model:value="form.firstName"
        :error-message="errors.firstName"
        type="text"
        placeholder="First name"
        name="first-name" />
    </div>

    <div>
      <p class="button-2 pb-2">Last name</p>
      <BaseInput
        v-model:value="form.lastName"
        :error-message="errors.lastName"
        type="text"
        placeholder="Last name"
        name="last-name" />
    </div>
    <div>
      <p class="button-2 pb-2">Date of birth</p>
      <BaseDateInput
        :value="form.dob"
        @update:value="(val) => (form.dob = val)"
        :error-message="errors.dob"
        name="dob" />
    </div>

    <!--      <p class="button-2 pb-2">Mobile number</p>-->
    <!--      <BaseInput-->
    <!--        v-model:value="form.mobileNumber"-->
    <!--        :error-message="errors.mobileNumber"-->
    <!--        v-model="form.mobileNumber"-->
    <!--        type="phone"-->
    <!--        placeholder="Mobile number"-->
    <!--        name="mobile-number" />-->

    <div
      class="flex flex-col gap-y-[10px]"
      v-if="whitelabel.identifier === 'CERTE_FINANCIAL_WELLBEING'">
      <p class="button-2">Company name</p>
      <Autocomplete
        type="certe-company-name"
        :get-items="
          async (val: string) => {
            const companyNames = [
              { value: 'maddocks', name: 'Maddocks' },
              { value: 'liberty_mutual_insurance', name: 'Liberty Mutual Insurance Group' },
            ]
            return companyNames.filter((item) =>
              item.name.toLowerCase().includes(val.toLowerCase()),
            )
          }
        "
        @selected="certeCompanyName = $event"
        :existing-item="certeCompanyName"
        placeholder="Search for your company"
        id="certe-autocomplete" />
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  date,
  InferOutput,
  maxValue,
  minLength,
  minValue,
  object,
  pipe,
  regex,
  string,
  transform,
} from 'valibot'
import Autocomplete from '@/components/BasicInputs/Autocomplete.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import BaseDateInput from '@/components/Inputs/BaseDateInput.vue'
import { subYears } from 'date-fns'
import { useValibotForm } from '@/composables/useValibotForm.ts'
import { onMounted, shallowRef } from 'vue'
import { useAuth0 } from '@/lib/AuthenticatorPlugin.ts'
import { useSessionStore } from '@/store/pinia/SessionStore.ts'

const auth0 = useAuth0()
const sessionStore = useSessionStore()
const whitelabel = sessionStore.getWhitelabelData
const certeCompanyName = shallowRef({ value: '', label: 'Select from dropdown' })

const UserDetailsSchema = object({
  firstName: pipe(
    string('Your first name must be a string.'),
    minLength(2, 'Your first name must be at least 2 characters long.'),
    regex(/^[a-zA-Z\s'.-]*$/, 'Your first name contains invalid characters.'),
  ),
  lastName: pipe(
    string('Your last name must be a string.'),
    minLength(2, 'Your last name must be at least 2 characters long.'),
    regex(/^[a-zA-Z\s'.-]*$/, 'Your last name contains invalid characters.'),
  ),
  dob: pipe(
    pipe(
      string('Please enter your date of birth.'),
      transform((input) => new Date(input)),
    ),
    pipe(
      date('Your date of birth must be a date.'),
      minValue(subYears(new Date(), 91), 'Sorry, the maximum age allowed is 91 years.'),
      maxValue(
        subYears(new Date(), 16),
        'You need to be at least 16 years old to create an account.',
      ),
    ),
  ),
  // mobileNumber: string('Your mobile number is invalid.', [
  //   minLength(10, 'Your mobile number is invalid.'),
  // ]),
})

export type UserForm = InferOutput<typeof UserDetailsSchema>

const { form, errors, validate } = useValibotForm<UserForm>(
  {
    firstName: '',
    lastName: '',
    dob: null,
    // mobileNumber: '',
  },
  UserDetailsSchema,
)

defineExpose({
  form,
  errors,
  validate,
})

onMounted(() => {
  if (auth0.user.value) {
    form.firstName = auth0.user.value.given_name ?? ''
    form.lastName = auth0.user.value.family_name ?? ''
    form.dob = auth0.user.value.dob ?? ''
  }
})

const capitalize = (str: string) => {
  return str[0].toUpperCase() + str.slice(1)
}
</script>

<style scoped></style>
